import React, { useState } from 'react'
import toast from 'react-hot-toast'
import { useHistory } from 'react-router-dom'
import { useMutation } from 'react-query'

import {
  Delete as DeleteIcon,
  Edit as EditIcon,
  Home as HomeIcon,
  Print as PrintIcon,
  TrackChanges as TrackChangesIcon,
} from '@material-ui/icons'

import { useAsyncPrint } from 'src/components/ToPrint/useAsyncPrint'
import { PlaceLabel } from 'src/components/PrintLabel/PlaceLabel'
import { PlaceDialog } from 'src/modules/supply_chain/components/PlaceDialog'
import { RelatedLinkedField, ValueField } from 'src/components/Table'
import { skuit } from 'src/services/skuit'
import { DetailComponent } from './base'

interface ObjInfo {
  data: any
  isLoading: boolean
}

interface DetailTableProps {
  obj: ObjInfo
  refresh?: () => void
}

export const PlaceDetailTable = (props: DetailTableProps) => {
  const { obj, refresh } = props
  const history = useHistory()
  const [updateOpen, setUpdateOpen] = useState(false)
  const { print, renderPrintComponent } = useAsyncPrint()

  const { mutate: markLost } = useMutation(skuit.sc.places.lost, {
    onSuccess: () => {
      toast.success(`Successfully sent containers & inventory to lost`)
      refresh?.()
    },
    onError: (error: any) => {
      toast.error(`Error: ${error.response.data}`)
    },
  })
  const { mutate: deletePlace } = useMutation(skuit.sc.places.delete, {
    onSuccess: () => {
      toast.success(`Successfully deleted ${obj.data.name}`)
      history.push('/warehouse/places')
    },
    onError: (error: any) => {
      toast.error(`Error: ${error.response.data}`)
    },
  })

  return (
    <>
      {renderPrintComponent()}
      {updateOpen && (
        <PlaceDialog
          open={updateOpen}
          place={obj.data}
          update
          handleClose={() => {
            setUpdateOpen(false)
          }}
          onSave={refresh}
        />
      )}
      <DetailComponent
        obj={obj}
        Icon={HomeIcon}
        menuItems={[
          {
            Icon: EditIcon,
            actions: [{ title: 'Edit Place', onClick: () => setUpdateOpen(true) }],
          },
          {
            Icon: PrintIcon,
            actions: [
              {
                title: 'Print Place Label',
                onClick: () => print((props) => <PlaceLabel {...props} obj={obj.data} />),
              },
            ],
          },
          {
            Icon: TrackChangesIcon,
            actions: [
              { title: 'Mark All Here Lost', onClick: () => markLost({ guid: obj.data.guid }) },
              {
                title: 'Mark All Lost (Including in Descendants)',
                onClick: () =>
                  markLost({ guid: obj.data.guid, data: { include_descendants: true } }),
              },
            ],
          },
          {
            Icon: DeleteIcon,
            condition: obj.data?.canDelete && skuit.auth.isSuperUser(),
            actions: [{ title: 'Delete Place', onClick: () => deletePlace(obj.data.guid) }],
          },
        ]}
        fields={[
          { id: 'guid', label: 'SquID', renderer: ValueField },
          { id: 'name', label: 'Name', renderer: ValueField },
          { id: 'facility', label: 'Facility', renderer: RelatedLinkedField(ValueField, 'name') },
          { id: 'parent', label: 'Parent Place', renderer: RelatedLinkedField(ValueField, 'name') },
        ]}
      />
    </>
  )
}
